namespace Matrix.Workflow {
    export interface ClientFunctionTriggerRow {
        TriggerCode?: string;
        Description?: string;
        FunctionName?: string;
        NavigationPath?: string;
        Permission?: string;
        ActionVerb?: string;
        DisplayOrder?: number;
        Icon?: string;
        Parameters?: string;
        ParameterList?: ClientFunctionTriggerParameter[];
        HasParameters?: boolean;
        IsActive?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace ClientFunctionTriggerRow {
        export const idProperty = 'TriggerCode';
        export const nameProperty = 'Description';
        export const localTextPrefix = 'Workflow.ClientFunctionTrigger';
        export const lookupKey = 'Workflow.ClientFunctionTrigger';

        export function getLookup(): Q.Lookup<ClientFunctionTriggerRow> {
            return Q.getLookup<ClientFunctionTriggerRow>('Workflow.ClientFunctionTrigger');
        }
        export const deletePermission = 'DataAdmin:ClientFunction';
        export const insertPermission = 'DataAdmin:ClientFunction';
        export const readPermission = 'Read:ClientFunction';
        export const updatePermission = 'DataAdmin:ClientFunction';

        export declare const enum Fields {
            TriggerCode = "TriggerCode",
            Description = "Description",
            FunctionName = "FunctionName",
            NavigationPath = "NavigationPath",
            Permission = "Permission",
            ActionVerb = "ActionVerb",
            DisplayOrder = "DisplayOrder",
            Icon = "Icon",
            Parameters = "Parameters",
            ParameterList = "ParameterList",
            HasParameters = "HasParameters",
            IsActive = "IsActive",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
